<template>
  <v-dialog persistent :value="value" max-width="290" @click:outside="close">
    <v-card>
      <v-card-title class="headline">
        Sortition deletion
      </v-card-title>
      <v-card-text>
        You are about to delete the sortition
        <span class="font-weight-bold">"{{ sortition.name }}"</span>, are you
        sure?
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" text @click="onCancel">
          No
        </v-btn>

        <v-btn color="red darken-1" text @click="onConfirm">
          Yes, delete it.
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { destroySortition } from "../../../api/sortition.api.js";
import { destroySortition as destroyDisplaySortition } from "../../../api/sortitionDisplay.api.js";

export default {
  name: "SortitionDeleteDialog",
  props: {
    value: {
      type: Boolean,
      required: true
    },
    sortition: {
      type: Object,
      required: true,
      default: () => ({})
    },
    isForDisplay: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit("input", false);
      this.$emit("close");
    },
    onCancel() {
      this.close();
    },
    onConfirm() {
      if (this.isForDisplay) {
        destroyDisplaySortition(this.sortition.id)
          .then(() => {
            this.close();
            this.$emit("delete", this.sortition);
          })
          .catch(() => {
            this.close();
          });
      } else {
        destroySortition(this.sortition.id)
          .then(() => {
            this.close();
            this.$emit("delete", this.sortition);
          })
          .catch(() => {
            this.close();
          });
      }
    }
  }
};
</script>

<style scoped></style>
